import { Autoplay, Navigation } from 'swiper/modules';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.mySwiper', {
    modules: [Autoplay],
    loop: true,
    spaceBetween: 12,
    initialSlide: 0,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: false,
      },
      1440: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
    },
  });
});
